import React, { memo } from 'react';
import Select from '../../../../../Elements/ids/InputElements/Select';
import { mapAddressFormatsToSelect } from '../../../../../Helpers/AddressHelper';

const FormatSelector = ({ addressState, setAddressState }) => {
  console.log(addressState.address?.format);
  return (
    <Select
      options={mapAddressFormatsToSelect()}
      defaultValue={addressState.address?.format}
      onChange={e => {
        setAddressState({ ...addressState, address: { ...addressState.address, format: e.target.value } });
      }}
    />
  );
};

export default memo(FormatSelector);
